import { artifactTypes } from 'shared/constants/artifactTypes';
import { emailFrequencies } from './emailFrequencies';
import { newsletterFrequencies } from './newsletterFrequencies';

export const defaultPreferences = {
  data: {
    preferences: {
      emailNotifications: {
        frequency: emailFrequencies.DISABLED,
        type: [],
      },
      newsFeed: {
        classifications: [],
        limitToFollowedAnalysts: false,
        news: [
          artifactTypes.RATING_NEWS,
          artifactTypes.MONITORING_NOTES,
          artifactTypes.RESEARCH,
          artifactTypes.COMMENTARY,
          artifactTypes.COMPANY_NEWS,
        ],
      },
      newsletter: {
        classifications: [],
        frequency: newsletterFrequencies.WEEKLY,
        limitToFollowedAnalysts: false,
        news: [],
        useNewsFeedPreferences: true,
      },
    },
  },
};
